document.addEventListener("DOMContentLoaded", function () {
  const cartIcon = document.querySelector(".cartIcon");
  const cartDrawer = document.querySelector(".cart-drawer");
  const loader = document.querySelector(".loading");

  if (!cartIcon || !cartDrawer || !loader) {
    console.error("Cart icon or cart drawer or loader not found");
    return;
  }

  // Open Cart Drawer
  function openCartDrawer() {
    const cartContainer = cartDrawer.querySelector(".vera-cart-container");
    const cartMobileContainer = cartDrawer.querySelector(".vera-cart-mobile-container");

    console.log("Opening cart drawer...");

    cartDrawer.classList.remove("hidden");
    document.documentElement.classList.add("overflow-hidden");

    setTimeout(() => {
      cartContainer.classList.add("translate-0");
      if (cartMobileContainer) {
        cartMobileContainer.classList.add("translateY-0");
      }
    }, 10);
  }

  // Close Cart Drawer
  function closeCartDrawer() {
    const cartContainer = cartDrawer.querySelector(".vera-cart-container");
    const cartMobileContainer = cartDrawer.querySelector(".vera-cart-mobile-container");

    console.log("Closing cart drawer...");

    cartContainer.classList.remove("translate-0");
    if (cartMobileContainer) {
      cartMobileContainer.classList.remove("translateY-0");
    }

    setTimeout(() => {
      cartDrawer.classList.add("hidden");
      document.documentElement.classList.remove("overflow-hidden");
    }, 300);
  }

  // Attach click event listener to the cart icon
  cartIcon.addEventListener("click", function () {
    if (!cartDrawer.classList.contains("hidden")) return; // Prevent reopening if already open
    openCartDrawer();
  });

  // Function to reattach event listeners to close buttons
  function attachCloseButtonListeners() {
    cartDrawer.querySelectorAll(".cart-close").forEach((closeButton) => {
      closeButton.addEventListener("click", function () {
        closeCartDrawer();
      });
    });
  }

  // Attach event listeners for close buttons on page load
  attachCloseButtonListeners();

// Function to update cart item counts
function updateCartItemCounts(count) {
  // Update cart count for elements with the .cart-count class
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
  
  // Update count for elements with the .items-count-block class
  document.querySelectorAll(".items-count-block").forEach((eli) => {
    eli.textContent = count;
  });


  console.log("Updated cart item counts to:", count);
}


  async function updateCartDrawer() {
    console.log("Updating cart drawer...");

    // Fetch updated cart drawer HTML (no redirect, just HTML)
    const res = await fetch("/?section_id=vera-cart", {
      method: "GET", // Explicitly use GET to avoid form submission issues
    });
    const text = await res.text();

    // Create a temporary container to parse the fetched HTML
    const html = document.createElement("div");
    html.innerHTML = text;

    // Query the new drawer content
    const newBox = html.querySelector(".vera-cart-section").innerHTML;

    // Replace the old content with the new content
    document.querySelector('.vera-cart-section').innerHTML = newBox;

    // Reattach event listeners to the close buttons
    attachCloseButtonListeners();
    attachQuantityChangeListeners();
    attachQuantitySelectListeners();

    console.log("Cart drawer updated successfully.");

    // Ensure the cart drawer remains open after updating
    
    // Ensure the cart drawer remains open after updating 
    if (!cartDrawer.classList.contains("hidden")) {  
  reapplyTranslateClasses();
} else {
      setTimeout(() => { 
    reapplyTranslateClasses(); 
  }, 10);
}

    applyStoredValues();  // Apply stored values on update
  }

  // Reapply translate classes
  function reapplyTranslateClasses() {
    const cartContainer = cartDrawer.querySelector(".vera-cart-container");
    const cartMobileContainer = cartDrawer.querySelector(".vera-cart-mobile-container");

    cartContainer.classList.add("translate-0");
    if (cartMobileContainer) {
      cartMobileContainer.classList.add("translateY-0");
    }

    console.log("Reapplied translate classes to cart drawer");
  }

  // Attach form submission event to add-to-cart forms
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      loader.classList.remove("hidden");
      console.log("Adding item to cart...");

      // Submit form with AJAX (no page reload)
      await fetch('/cart/add', {
        method: "POST",
        body: new FormData(form),
      });

      
      await updateCartDrawer();
      loader.classList.add("hidden");
      // Open the cart drawer after adding to cart
      openCartDrawer();


      console.log("Item added to cart.");

     
      
    });
  });

  // Attach event listeners for mobile quantity select changes
  function attachQuantitySelectListeners() {
    document.querySelectorAll(".vera-cart-items-mobile-quantity-selection").forEach((select) => {
      // Apply stored value if it exists
      const storedValue = localStorage.getItem(select.name);
      if (storedValue) {
        select.value = storedValue;
      }

      select.addEventListener("change", async (e) => {
        const selectedQuantity = Number(e.target.value);
        const rootItem = select.closest(".vera-cart-items, .vera-cart-mobile-items");
        const key = rootItem.getAttribute("data-line-item-key");

        // Store the selected value
        localStorage.setItem(select.name, e.target.value);

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: selectedQuantity } }),
        });

        const cart = await res.json();

        // Update UI
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
        reapplyTranslateClasses();
      });
    });
  }
  
  // Attach event listeners for item quantity changes
  function attachQuantityChangeListeners() {
  // Attach listeners for quantity increment/decrement buttons
  document.querySelectorAll(".vera-cart-items-quantity-inc-btn, .vera-cart-items-quantity-dec-btn").forEach((button) => {
    button.addEventListener("click", async (e) => {
      e.preventDefault();

      const rootItem = button.closest(".vera-cart-items, .vera-cart-mobile-items");
      const key = rootItem.getAttribute("data-line-item-key");
      const currentQuantity = Number(rootItem.querySelector(".vera-cart-items-quantity, .vera-cart-mobile-items-quantity").value);
      const isIncreasing = button.classList.contains("vera-cart-items-quantity-inc-btn");
      const newQuantity = isIncreasing ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);

      // Ajax update
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);
      await updateCartDrawer();
      reapplyTranslateClasses();
    });
  });

  // Attach listener for trash icon to set quantity to 0
  document.querySelectorAll(".remove-items").forEach((trashIcon) => {
    trashIcon.addEventListener("click", async (e) => {
      e.preventDefault();

      const rootItem = trashIcon.closest(".vera-cart-items, .vera-cart-mobile-items");
      const key = rootItem.getAttribute("data-line-item-key");

      // Set quantity to 0
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });
      const cart = await res.json();

      updateCartItemCounts(cart.item_count);
      await updateCartDrawer();
      reapplyTranslateClasses();
    });
  });
}

  // Apply stored values on page load or cart drawer update
  function applyStoredValues() {
    document.querySelectorAll(".vera-cart-items-mobile-quantity-selection").forEach((select) => {
      const storedValue = localStorage.getItem(select.name);
      if (storedValue) {
        select.value = storedValue;
      }
    });
  }

  // Attach quantity change listeners on page load
  attachQuantityChangeListeners();
  attachQuantitySelectListeners();
  applyStoredValues();  // Apply stored values on page load
});

